
var bar = new ProgressBar.Line(progress_bar, {
    strokeWidth: 4,
    easing: 'easeInOut',
    duration: 1400,
    color: '#bd4063',
    trailColor: '#fff',
    trailWidth: 4,
    svgStyle: {width: '100%', height: '10px'},  
});
$('#ca-reseau').contentcarousel();
bar.animate(0);  
var R1, R2, R3, R4, R5, R6;
var NbrRep = 0;
var NbrRep4 = 0;
var NbrRep5 = 0;
var NbrRep6 = 0;
var idThis3 = '';
var idThis4 = '';
var idThis5 = '';
var idThis6 = '';
var comptProgress = 0;
var idThis7 = '';
var Issteep = 0;
var secure = 0;
var rep = 1;
var idThis = '';
var idIt = '';
var secure5 = 0;
var secure6 = 0;
var secure2 = 0;
var idThis2 = '';
var idIt2 = '';
var Sens = '';
var IsTerne = 0;
var itisthe = 'A2B1E1';
var compteur = 0;
var stockRep = [];
var  reponseInTableau = {
    32:             ['A1E1','A2E1','A3E1'], //SHAMPOOING TINCTO BLOND
    34:             ['A1E2','A2E2','A3E2'], //SHAMPOOING TINCTO ROUX
    36:             ['A1E3','A2E3','A3E3','A1E4','A2E4','A3E4'], // SHAMPOOING TINCTO BRUN
    88:             ['A1E5','A2E5','A3E5'], // SHAMPOING ARGENT
    48:             ['A1D1','A2D1','A3D1'], // SHAMPOOING ALGUE
    25:             ['A1C1','A1C2','A2C1','A2C2','A3C1','A3C2'],    //COMPLEXE A
    26:             ['A1C4','A2C4','A3C4'], //COMPLEXE B
    46:             ['A1D1','A2D1','A3D1'], //REMARKABLE
    44:             ['A1B3G1','A2B3G1','A1D1','A2D1','A3D1','A1B1G1','A2B1G1','A3B1G1'], //ETONNANT
    50:             ['A1D1','A2D1','A3D1'], // UNIQUE
    49:             ['A1D1','A2D1','A3D1'], //MASQUE ALGUE
    38:             ['A1E1','A2E1','A3E1'], //MASQUE TINCTO BLOND
    40:             ['A1E2','A2E2','A3E2'], //MASQUE TINCTO ROUX
    42:             ['A1E3','A2E3','A3E3','A1E4','A2E4','A3E4'], // MASQUE TINCTO BRUN
    56:             ['A1D5','A1B1G2','A1B3G3','A2B3G3','A1B3G2'], //INDEMODABLE
    60:             ['A1D5','A1B3G2','A2B3G2','A3B3G2','A2B1G2','A1B1G3','A2B1G3'], //PATE COIFFANTE FORTE
    61:             ['A2D5','A1B1G2'], //PATE COIFFANTE SOUPLE
    54:             ['A2D5','A3D5','A1B1G1','A2B1G1','A3B1G1','A2B1G3','A2B3G3'], //CREME COIFFANTE
    53:             ['A3D5', 'A2D5', 'A2B3G3'], //CIRE COIFFANTE
    59:             ['A1D2','A2D3','A2D2','A3D2','A3D3','A1B3G1','A1B1G1','A2B1G1','A2B3G1','A3B1G1','A3B3G1','A3B1G3','A3B3G3','A1D3','A1B3G2','A2B1G2','A2B3G2'], //GELEE COIFFANTE
    57:             ['A1D3','A1B3G3','A1B1G3','A2B1G3','A2B3G3','A2B1G2','A2B3G2'],   // MOUSSE COIFFANTE
    52:             ['A1B1G3', 'A2B1G3'],  // GEL COIFFANT
};

function restartQuizz(){
    location.reload();
}     

function startQuizz(){
    $('#containerBtnretour').css('display', 'none');

    $('#HommeSteep').addClass('bounceOut');
    $('#HommeSteep').css('display', 'none');
    $("#backpages").fadeOut(50,function() {
        $("#backpages").css('background', ("url('/images/quizz/fond1.jpg')"));
        $("#backpages").fadeIn(50);
    });
    $('#steep0').addClass('bounceIn');
    $('#steep0').css('display', 'block');
   
    $('#progress_bar').css('display', 'block');

    $('#containerBtnRestart').css('display', 'block');
}
function searchCombi(comb, color){
    var AlreadyExist = 0;
    for (var id in reponseInTableau) { 
        for (var i = 0; i < reponseInTableau[id].length; i++) {
            if (comb == reponseInTableau[id][i]) {
                for (var j = 0; j < stockRep.length; j++) {
                    if (stockRep[j] == id) {
                        AlreadyExist = 1;
                        console.log('AlreadyExist -> 1 : ' + comb);
                    }
                }
                if (AlreadyExist == 0) {
                    console.log('AlreadyExist ->0 : ' + comb);
                    if (id == 'ShampoingTincto' || id == 'MasqueTincto' ) {
                        var temp = id +' ['+ color + ']';
                        stockRep.push(temp); 
                        console.log('AlreadyExist : ' + comb);
                    }
                    else{
                        stockRep.push(id);
                        console.log('comb -> ' + comb + ' id : ' +id);
                    }
                }
            }
        }
    } 
    
}

var tableauReponse = new Array();
tableauReponse[2] = new Array();
tableauReponse[3] = new Array();
tableauReponse[4] = new Array();
tableauReponse[5] = new Array();
tableauReponse[7] = new Array();




// MAIN FULLSCREEN NAVIGATION
$(document).ready(function(){
    $('.menu-btn').click(function(){
        $('.fullscreen-nav').toggleClass('open');
        $('.content-website').toggleClass('open-menu');
        $('.overlay-website').toggleClass('actif');
        $(this).toggleClass('close-btn');
    })
})  
$(document).ready(function(){
    $('.reponseColor').click(function(){
        
            idIt = $(this).attr('id');
            
            if (idIt == idThis7) {
                $(this).css('box-shadow', 'rgba(0, 0, 0, 0.4) 0px 0px 9px 2px');
                $(this).css('color', '#000');
                idIt = '';
                
            } 
            if (rep == 5 && secure5 == 0) {           
                $(this).css('box-shadow', 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px');
                $(this).css('color', 'white');
                 $('.next-step').css('visibility', 'initial');
                idThis7 = $(this).attr('id');
                
                secure5 = 1;
                tableauReponse[7][1] = idThis7;
                console.log('ID : ' + idThis7);
                nextQuiz('N');
            }
            if (idIt == '') {
                secure5 = 0;
                idThis7 = '';
            }

            $('#backpages').removeClass('bounceInRight');
        
    });
    $('.reponseColorTech').click(function(){
        
            idIt = $(this).attr('id');
            
            if (idIt == idThis) {
                $(this).css('box-shadow', 'rgba(0, 0, 0, 0.4) 0px 0px 9px 2px');
                $(this).css('color', '#000');
                $('.next-step').css('visibility', 'hidden');
                idIt = '';
                
            } 
            if (rep == 6 && secure6 == 0) {           
                $(this).css('box-shadow', 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px');
                $(this).css('color', 'white');
                $('.next-step').css('visibility', 'initial');
                nextQuiz('N');
                idThis = $(this).attr('id');
                
                secure6 = 1;
                tableauReponse[4][1] = idThis;
            }
            if (idIt == '') {
                secure6 = 0;
                idThis = '';
            }

            $('#backpages').removeClass('bounceInRight');
        
    });
    $('.reponse').click(function(){
        $('#backpages').removeClass('bounceInRight');
        if (rep == 1) {
            idIt = $(this).attr('id');
            console.log('REP 1');
            if (idIt == idThis) {
                $(this).css('box-shadow', 'rgba(0, 0, 0, 0.4) 0px 0px 9px 2px');
                $(this).css('color', '#000');
                $('.next-step').css('visibility', 'hidden');
                idIt = '';
                
            } 
            if (rep == 1 && secure == 0) {           
                $(this).css('box-shadow', 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px');
                $(this).css('color', 'white');
                nextQuiz('N');
                idThis = $(this).attr('id');
                secure = 1;
                tableauReponse[0] = idThis;
            }
            if (idIt == '') {
                secure = 0;
                idThis = '';
            }


        }
        else if (rep == 2) {
            idIt2 = $(this).attr('id');
            console.log('REP 2');
            if (idIt2 == idThis2) {
                $(this).css('box-shadow', 'rgba(0, 0, 0, 0.4) 0px 0px 9px 2px');
                $(this).css('color', '#000');
                $('.next-step').css('visibility', 'hidden');
                idIt2 = '';
                
            } 
            if (rep == 2 && secure2 == 0) {           
                $(this).css('box-shadow', 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px');
                $(this).css('color', 'white');
                nextQuiz('N');
                idThis2 = $(this).attr('id');
                var tempOf = $(this).attr('idOf');
                secure2 = 1;
                tableauReponse[1] = tempOf;
            }
            if (idIt2 == '') {
                secure2 = 0;
                idThis2 = '';
            }
        }
            
        else if(rep == 3){
            console.log('REP 3');
            var back = $(this).css('box-shadow');
            if (back == 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px') {
                idThis3 = $(this).attr('id');
                if (idThis3 == 'C1') {
                    $('#opacimgC3').hide();
                }
                if (idThis3 == 'C2') {
                    $('#opacimgC3').hide();
                }
                if (idThis3 == 'C3') {
                    $('#opacimgC1').hide();
                    $('#opacimgC2').hide();
                    $('#opacimgC4').hide();
                }
                if (idThis3 == 'C4') {
                    $('#opacimgC3').hide();
                }
                if (idThis3 == 'C3') {
                    $('#opacimgC1').hide();
                }
                if (idThis3 == 'C2') {
                    $('#opacimgC4').hide();
                }
                if (idThis3 == 'C4') {
                    $('#opacimgC2').hide();
                }
                $(this).css('box-shadow', 'rgba(0, 0, 0, 0.4) 0px 0px 9px 2px');
                $(this).css('color', '#000');
                tableauReponse[2].splice($.inArray(idThis3, tableauReponse[2]),1);
                NbrRep = NbrRep - 1;
                if (NbrRep == 0) {
                    $('.next-step').css('visibility', 'hidden');
                }
            }else{
                
                $(this).css('box-shadow', 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px');
                $(this).css('color', 'white');
                $('.next-step').css('visibility', 'initial');
                idThis3 = $(this).attr('id');
                if (idThis3 == 'C1') {
                    $('#opacimgC3').show();
                }
                if (idThis3 == 'C2') {
                    $('#opacimgC3').show();
                }
                if (idThis3 == 'C3') {
                    $('#opacimgC1').show();
                    $('#opacimgC2').show();
                    $('#opacimgC4').show();
                }
                if (idThis3 == 'C4') {
                    $('#opacimgC3').show();
                }
                if (idThis3 == 'C3') {
                    $('#opacimgC1').show();
                }
                if (idThis3 == 'C2') {
                    $('#opacimgC4').show();
                }
                if (idThis3 == 'C4') {
                    $('#opacimgC2').show();
                }
                tableauReponse[2][NbrRep] = idThis3;

                NbrRep = NbrRep + 1;
            }
        }
        else if(rep == 4){
            console.log('REP 4');
            var back = $(this).css('box-shadow');
            if (back == 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px') {
                idThis4 = $(this).attr('id');
                if (idThis4 == 'D3') {
                    $('#D5').css('cursor','pointer');
                    $('#opacimgD5').hide();
                }
                if (idThis4 == 'D5') {
                    $('#D3').css('cursor','pointer');
                    $('#opacimgD3').hide();
                }
                if (idThis4 == 'D2') {
                    $('#D4').css('cursor','pointer');
                    $('#opacimgD4').hide();
                }
                if (idThis4 == 'D4') {
                    $('#D2').css('cursor','pointer');
                    $('#opacimgD2').hide();
                }
                $(this).css('box-shadow', 'rgba(0, 0, 0, 0.4) 0px 0px 9px 2px');
                $(this).css('color', '#000');
                tableauReponse[3].splice($.inArray(idThis4, tableauReponse[3]),1);
                NbrRep4 = NbrRep4 - 1;
                if (NbrRep4 == 0) {
                    $('.next-step').css('visibility', 'hidden');
                }
            }else{
                $(this).css('box-shadow', 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px');
                $(this).css('color', 'white');
                $('.next-step').css('visibility', 'initial');
                idThis4 = $(this).attr('id');
                if (idThis4 == 'D3') {
                    $('#D5').css('cursor','no-drop');
                    $('#opacimgD5').show();
                }
                if (idThis4 == 'D5') {
                    $('#D3').css('cursor','no-drop');
                    $('#opacimgD3').show();
                }
                if (idThis4 == 'D2') {
                    $('#D4').css('cursor','no-drop');
                    $('#opacimgD4').show();
                }
                if (idThis4 == 'D4') {
                    $('#D2').css('cursor','no-drop');
                    $('#opacimgD2').show();
                }
                tableauReponse[3][NbrRep4] = idThis4;

                NbrRep4 = NbrRep4 + 1;
            }
        }

        else if(rep == 7){
            console.log('REP 7');
            var back = $(this).css('box-shadow');
            if (back == 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px') {
                idThis6 = $(this).attr('id');
                if (idThis6 == 'G1') {
                    $('#opacimgG3').hide();
                }
                if (idThis6 == 'G3') {
                    $('#opacimgG1').hide();
                }
                if (idThis6 == 'G2') {
                    $('#opacimgG4').hide();
                }
                if (idThis6 == 'G4') {
                    $('#opacimgG2').hide();
                }
                
                $(this).css('box-shadow', 'rgba(0, 0, 0, 0.4) 0px 0px 9px 2px');
                $(this).css('color', '#000');
                tableauReponse[5].splice($.inArray(idThis5, tableauReponse[5]),1);
                NbrRep6 = NbrRep6 - 1;
                if (NbrRep6 == 0) {
                    $('.next-step').css('visibility', 'hidden');
                }
            }else{
                $(this).css('box-shadow', 'rgba(255, 255, 255, 0.4) 0px 0px 9px 2px');
                $(this).css('color', 'white');
                $('.next-step').css('visibility', 'initial');
                idThis6 = $(this).attr('id');
                if (idThis6 == 'G1') {
                    $('#opacimgG3').show();
                }
                if (idThis6 == 'G3') {
                    $('#opacimgG1').show();
                }
                if (idThis6 == 'G2') {
                    $('#opacimgG4').show();
                }
                if (idThis6 == 'G4') {
                    $('#opacimgG2').show();
                }
                tableauReponse[5][NbrRep6] = idThis6;

                NbrRep6 = NbrRep6 + 1;
            }
        }

        

        
        
    })
    
}) 
function doalert(element){
    if(element.checked) {
        $('#qubis').css('display', 'block');
    }else{
        $('#qubis').css('display', 'none');
    }
}

function changement(steep, sens){
    
    if (sens == 'n') {
        
        var precsteep = steep - 1;
        

        $('#backpages').css('overflow', 'hidden');
        $('#steep' + precsteep).removeClass('bounceInRight');
        $('#steep' + steep).removeClass('bounceOutLeft');

        $('#steep' + precsteep).css('display', 'none');
        $('#steep' + precsteep).addClass('bounceOutLeft');
        $('#steep' + steep).css('display', 'block');
        $('#steep' + steep).addClass('bounceInRight');

    }
    if (steep == 6) {
        if (tableauReponse[0] == 'A2' || tableauReponse[0] == 'A3' || tableauReponse[0] == 'A4') {
            $('#E5Cont').css('display', 'block');

            $('#E1Cont').removeClass('col-md-4');
            $('#E2Cont').removeClass('col-md-4');
            $('#E3Cont').removeClass('col-md-4');
            $('#E4Cont').removeClass('col-md-4');

            $('#E1Cont').addClass('col-md-3');
            $('#E2Cont').addClass('col-md-3');
            $('#E3Cont').addClass('col-md-3');
            $('#E4Cont').addClass('col-md-3');
        }else{
            $('#E5Cont').css('display', 'none');
           
        }
    }
    if (steep == 7) {
        var comptCarr = 0;
        $('#containerBtnRestart').css('color', '#555');
        comptProgress = 1;
        bar.animate(comptProgress);
        stockRep = [];
        var tabcombisave = [];
       
        $('.EndReponse').empty();
        
        R1 = tableauReponse[0];
        R2 = tableauReponse[1];
        R3 = tableauReponse[2];
        R4 = tableauReponse[3];
        R5 = tableauReponse[5];
        R7 = tableauReponse[7];
        R4B= tableauReponse[4][1];
        colorCheveux = tableauReponse[4][0];
        var CombinaisonR1R3 ;
        var CombinaisonR1R4;
        var CombinaisonR1R4R4B;
        var CombinaisonR1R2R5;
        var CombinaisonR1R7;
        for (var j = 0; j < tableauReponse[7].length; j++) {
            var t = j+1;
            R7 = tableauReponse[7][j];
            CombinaisonR1R7 = R1 + R7 ;
            tabcombisave.push(CombinaisonR1R7);
            searchCombi(CombinaisonR1R7);
           
            
        }
        for (var j = 0; j < tableauReponse[3].length; j++) {
            var t = j+1;
            R4 = tableauReponse[3][j];
            CombinaisonR1R4 = R1 + R4;
            tabcombisave.push(CombinaisonR1R4);
            console.log('R1R4 : ' +CombinaisonR1R4);
            searchCombi(CombinaisonR1R4, '');

           
        }
        for (var j = 0; j < tableauReponse[2].length; j++) {
            var t = j+1;
            R3 = tableauReponse[2][j];
            CombinaisonR1R3 = R1 + R3;
            console.log('R1R3 : ' +CombinaisonR1R3);
            tabcombisave.push(CombinaisonR1R3);
            searchCombi(CombinaisonR1R3, '');
                    
            
        }
        

        for (var j = 0; j < tableauReponse[5].length; j++) {
            var t = j+1;
            R5 = tableauReponse[5][j];
            CombinaisonR1R2R5 = R1 + R2 + R5;
            tabcombisave.push(CombinaisonR1R2R5);
            searchCombi(CombinaisonR1R2R5,'');
            
        }

        for (var j = 0; j < tableauReponse[3].length; j++) {
            var t = j+1;
            R4 = tableauReponse[3][j];

            CombinaisonR1R4R4B = R1 + R4 + R4B;
            tabcombisave.push(CombinaisonR1R4R4B);
            searchCombi(CombinaisonR1R4R4B, colorCheveux);
           
            
        }
        
        var urlResult= 'searchProduct/';
        var thsiii = 0;
        for (var i = 0; i < stockRep.length; i++) {
            thsiii = i + 1;
           
            
            if (i == stockRep.length-1) {
                urlResult = urlResult + stockRep[i];
            }
            else{
                urlResult = urlResult + stockRep[i] + '-';
            }
            
                
                
        }

        console.log('url : ' + urlResult);
        window.location.href = urlResult; 
        // SWIPE MOBILE
        
    }
        
            
}

function nextQuiz(element){
    window.scrollTo(0, 0);
    if (element == 'N') {
         Issteep = Issteep + 1;
         Sens = 'n';
    }
    if (element == 'P') {
         Issteep = Issteep - 1;
         Sens = 'p';
    }
    if (Issteep == 0) {
        $('#btnPrec').css('display', 'none');
    }else{
        $('#btnPrec').css('display', 'block');
    }
    
    
   
    comptProgress = comptProgress + 0.16;
    
    if (Issteep == 4 && Sens == 'p') {
        for (var k = 0; k < tableauReponse[3].length; k++) {
            if (tableauReponse[3][k] == 'D5') {
                
                Issteep = 4;
                
                IsTerne = 1;
                k = tableauReponse[3].length;
            }
            else{             
                Issteep = 3;

            }
            
        }
            
    }
    
    if (Issteep == 0) {
        rep = 1;
    }
    else if(Issteep == 1){
        rep = 2;
    }
    else if(Issteep == 2){
        rep = 3;
    }
    else if(Issteep == 3){
        rep = 4;
    }
    else if(Issteep == 4){
        rep = 5;

    }
    else if(Issteep == 5){
        rep = 6;
        
    }
    else if(Issteep == 6){
        rep = 7;
        
    }
    
    var nbrFond = Issteep + 1;
    bar.animate(comptProgress);
    

    
  
    $('.next-step').css('visibility', 'hidden');
                
    $("#backpages").fadeOut(300,function() {
        $("#backpages").css('background', ("url('/images/quizz/fond" + nbrFond+".jpg')"));
        $("#backpages").fadeIn(300);
    });
    changement(Issteep , Sens );
    
    

    
}

